import { createContext, useContext, useEffect, useState } from 'react';
import { loader } from './LoaderBridge';

const LoaderContext = createContext();
export const useLoader = () => useContext(LoaderContext);

export function LoaderProvider({ children }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loader.set(setLoading);
  }, []);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoaderContext.Provider>
  );
}
